import React from 'react';

const ReplyForm = ({ commentError, replyMsg, handleReplyMsgChange, handlePostReply, handleCancelReply, index }) => {
  return (
    <div className="reply-form">
      <span className="error">{commentError}</span>
      <textarea
        className="reply-textarea"
        placeholder="Type Your Reply"
        value={replyMsg}
        onChange={handleReplyMsgChange}
      ></textarea>
      <div className="reply-btn-container">
        <button
          className="btn reply-btn"
          onClick={(e) => handlePostReply(index, e)}
        >
          Post Reply
        </button>
        <button
          className="btn cancel-reply-btn"
          onClick={handleCancelReply}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default ReplyForm;
